import Layout from '@/components/layout/LayoutWrapper';
import PremiumConfirmationV2 from '@/components/PremiumConfirmationV2';
import { InitRequest, useInitState } from '@/hooks/store';

const PremiumConfirmationPage = () => {
	useInitState({
		requests: [InitRequest.USER, InitRequest.DEVICE],
	});

	return (
		<Layout pageName="premium-confirmation">
			<PremiumConfirmationV2 />
		</Layout>
	);
};

export default PremiumConfirmationPage;
